import React,{useContext} from "react";
import { useNavigate } from "react-router-dom";
import { contextApiActions } from "../../../_redux/_constants";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import { UiAccordian } from "../../_uiComponents/common/form/UiToggleArea";
import LookUpTableFilterForm from "./forms/FactTableFilterForm";
import { SearchBarWr } from "../../_uiComponents/common/form/UiInputComponents";
import FactTableManagement from "./views/FactTableManagement";
import CreateByFileImport from "./views/CreateByFileImport";
import { Context } from "../../../_context/Store";

export default function FactTableWrapper() {
     const navigate = useNavigate();
     const [state, dispatch] = useContext(Context);

     const createByFileImport = () => {
          dispatch({
               type: contextApiActions.UI_EXTRA_LARGE_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Create By File Import",
                    children: <CreateByFileImport/>,
               },
          });
     };

     return (
          <>
               <MainLeftTitle title="Fact Table Management">
                    <div className="sb-lookup-table-create-btn">
                         <CreateButton
                              name="Create"
                              onClick={() => navigate("/app/fact-data-manage/add")}
                         />
                    </div>
                    <div className="sb-lookup-table-create-btn">
                         <CreateButton
                              name="Create By File Import"
                              onClick={createByFileImport}
                         />
                    </div>
                    
               </MainLeftTitle>
               
               <FactTableManagement />
          </>
     );
}
